module.exports = __webpack_public_path__ + "img/tm.tm61ac9a0.svg";